import { Routes } from '@angular/router';

export default [
  {
    path: 'diagnostic',
    data: { title: 'Segmentation par diagnostic' },
    loadComponent: () =>
      import('./diagnostic/segmentation-diagnostic').then(
        (m) => m.SegmentationDiagnostic,
      ),
  },
  {
    path: 'intervention',
    data: { title: 'Segmentation En Centre / SAD' },
    loadComponent: () =>
      import('./intervention/segmentation-intervention').then(
        (m) => m.SegmentationIntervention,
      ),
  },
  {
    path: 'reparateur',
    data: { title: 'Segmentation par réparateur' },
    loadComponent: () =>
      import('./repairer/segmentation-repairer').then(
        (m) => m.SegmentationRepairer,
      ),
  },
] as Routes;
